module.exports = __webpack_public_path__ + "static/img/WarmPlate (2).ba0606a1.png";